// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Row, Col, ChartJS } from "@components";

type OwnProps = $Exact<{
  reportData: *,
  title: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const CurrentOpenAbsencesPerReason = ({ reportData, title, t }: Props) => {
  return (
    <Row>
      <Col sm={12} className="p-0">
        <ChartJS
          type="bar"
          title={title}
          className="mb-4"
          data={{
            labels: (reportData || []).map(([label]) => label),
            datasets: [
              { label: t("SHORT_TERM_ABSENCE"), data: (reportData || []).map(([, s]) => s) },
              { label: t("LONG_TERM_ABSENCE"), data: (reportData || []).map(([, , l]) => l) },
            ],
          }}
          options={{ height: 300, isStacked: true, wrapXAxisLabels: true }}
        />
      </Col>
    </Row>
  );
};

export default localize()(CurrentOpenAbsencesPerReason);
